import React from "react";

import * as frontLoaderActions from "../actions/frontLoaderActions";
import { useRequestAfterEverySiteLoad } from "../hooks/requestStatusHooks";

const StainGate = ({
  children,
  LoadingEl,
  justStains,
}: {
  children: React.ReactNode;
  LoadingEl: ({
    className,
    children,
  }: {
    className?: string;
    children?: React.ReactNode;
  }) => React.ReactElement;
  justStains?: boolean;
}) => {
  const stainsReady = useRequestAfterEverySiteLoad(
    frontLoaderActions.frontLoadStains
  );

  let labStainsReady = true,
    externalLabsReady = true,
    externalLabStainsReady = true,
    labPanelsReady = true;

  if (!justStains) {
    labStainsReady = useRequestAfterEverySiteLoad(
      frontLoaderActions.frontLoadLabStains
    );
    externalLabsReady = useRequestAfterEverySiteLoad(
      frontLoaderActions.frontLoadExternalLabs
    );
    externalLabStainsReady = useRequestAfterEverySiteLoad(
      frontLoaderActions.frontLoadExternalLabStains
    );
    labPanelsReady = useRequestAfterEverySiteLoad(
      frontLoaderActions.frontLoadLabPanels
    );
  }

  if (
    !(
      stainsReady &&
      labStainsReady &&
      externalLabsReady &&
      externalLabStainsReady &&
      labPanelsReady
    )
  ) {
    return <LoadingEl className="StainGate">Loading Stains...</LoadingEl>;
  }

  return <>{children}</>;
};

export default StainGate;
